import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          用户评价
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-heading font-bold text-foreground-950">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}